import React, { useState } from 'react';
import { Menu as MenuIcon, NotificationsNone } from '../ui/icons';
import { useAuth } from '../../context/AuthContext';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { useNotifications } from '../../context/NotificationContext';
import { useLanguageNavigate } from '../../hooks/useLanguageNavigate';
import NotificationPanel from '../notifications/NotificationPanel';
import AssistantLauncher from '../assistant/AssistantLauncher';

interface DashboardNavbarProps {
    onMenuClick: () => void;
}

const DashboardNavbar: React.FC<DashboardNavbarProps> = ({ onMenuClick }) => {
    const { currentUser } = useAuth();
    const { isDarkMode } = useCustomTheme();
    const { unreadCount } = useNotifications();
    const languageNavigate = useLanguageNavigate();
    const [notifAnchor, setNotifAnchor] = useState<HTMLElement | null>(null);

    const initial =
        currentUser?.companyData?.contactPerson?.firstName?.charAt(0) ||
        currentUser?.email?.charAt(0).toUpperCase() ||
        '?';

    return (
        <div className="fixed top-0 left-0 right-0 md:hidden z-[1301] backdrop-blur-xl border-b bg-surface/90 border-line">
            <div className="flex items-center justify-between h-16 px-4">
                <div className="flex items-center">
                    <button
                        aria-label="menu"
                        onClick={onMenuClick}
                        className="mr-4 p-2 rounded-full text-primary bg-primary/10 hover:bg-primary/20 transition-colors duration-200"
                    >
                        <MenuIcon size={24} />
                    </button>
                    <img
                        src={isDarkMode ? '/Logo_Trinis_Basic-white.svg' : '/Logo_Trinis_Basic.svg'}
                        alt="TRINIS"
                        onClick={() => languageNavigate('/dashboard')}
                        className="h-6 w-auto object-contain cursor-pointer"
                    />
                </div>

                <div className="flex items-center gap-2">
                    <AssistantLauncher variant="navbar" />
                    <button
                        className={`relative p-2 rounded-full transition-colors duration-200 ${
                            unreadCount > 0 ? 'text-primary' : 'text-muted'
                        }`}
                        onClick={(e) => setNotifAnchor(e.currentTarget)}
                    >
                        <NotificationsNone size={24} />
                        {unreadCount > 0 && (
                            <span className="absolute -top-0.5 -right-0.5 flex items-center justify-center h-[18px] min-w-[18px] px-1 rounded-full bg-primary text-white text-[0.65rem] font-bold shadow-card">
                                {unreadCount}
                            </span>
                        )}
                    </button>
                    <div
                        onClick={() => languageNavigate('/settings')}
                        className="w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold cursor-pointer shadow-card"
                    >
                        {initial}
                    </div>
                </div>
            </div>

            <NotificationPanel
                anchorEl={notifAnchor}
                onClose={() => setNotifAnchor(null)}
            />
        </div>
    );
};

export default DashboardNavbar;
